import React, { useContext, useMemo, useRef, useState } from "react";
import { useUpdateEffect } from "ahooks";

export const GroupDevicesContext = React.createContext({});
export const GroupDevicesActionContext = React.createContext({});

export const useGroupDeviceState = () => {
  return useContext(GroupDevicesContext);
};

export const useGroupDeviceDispatch = () => {
  return useContext(GroupDevicesActionContext);
};

function getLocalStorage(name, defaultState) {
  const lastState = localStorage.getItem(name);
  if (lastState) {
    return JSON.parse(lastState);
  }
  return defaultState;
}

export function setLastGroupState(state) {
  requestAnimationFrame(() => {
    if (!state) {
      localStorage.removeItem("__lastGroupState");
    } else {
      localStorage.setItem("__lastGroupState", JSON.stringify(state));
    }
  });
}

export function getIntialGroupState() {
  const lastGroupState = getLocalStorage("__lastGroupState", {
    loadingGroup: true,
    reloadTreeFlag: 0
  });
  lastGroupState.loadingGroup = true;
  return lastGroupState;
}

export default ({ children }) => {
  const [state, setCurrentState] = useState(getIntialGroupState);
  const lastSingleSelectedGroup = useRef(
    getLocalStorage("__lastSelectGroupState")
  );

  const action = useMemo(() => {
    return {
      setCurrentGroup: (info, resetTag) => {
        lastSingleSelectedGroup.current = info;
        setCurrentState(preState => ({
          ...preState,
          loadingGroup: false,
          currentGroup: info,
          currentTag: resetTag ? null : preState.currentTag,
          filterByMode: false
        }));
        requestAnimationFrame(() => {
          localStorage.setItem("__lastSelectGroupState", JSON.stringify(info));
        });
      },
      updateCurrentGroup: info => {
        setCurrentState(preState => ({
          ...preState,
          currentGroup: { ...preState.currentGroup, ...info },
          currentTag: null,
          filterBy: "",
          filterByMode: false
        }));
      },
      resetCurrentGroup: (clear, callback) => {
        setCurrentState(preState => {
          const newState = {
            ...preState,
            currentGroup: clear ? null : lastSingleSelectedGroup.current,
            currentTag: null,
            filterBy: "",
            filterByMode: false
          };
          callback?.(newState);
          return newState;
        });
      },
      setLoadingGroup: bool => {
        setCurrentState(preState => ({
          ...preState,
          loadingGroup: bool
        }));
      },
      setCurrentTag: tag => {
        setCurrentState(preState => ({
          ...preState,
          currentGroup: null,
          currentTag: tag,
          loadingGroup: false,
          filterByMode: false
        }));
      },
      setFilterByMode: bool => {
        setCurrentState(preState => ({
          ...preState,
          filterByMode: bool,
          currentGroup: null,
          currentTag: null
        }));
      },
      setFilterBy: filterBy => {
        setCurrentState(preState => ({
          ...preState,
          filterByMode: true,
          filterBy: filterBy || preState.filterBy,
          currentGroup: null,
          currentTag: null,
          loadingGroup: false
        }));
      },
      reloadCategoryTree: () => {
        setCurrentState(preState => ({
          ...preState,
          reloadTreeFlag: preState.reloadTreeFlag + 1
        }));
      }
    };
  }, []);

  useUpdateEffect(() => {
    setLastGroupState(state)
  }, [state]);

  return (
    <GroupDevicesContext.Provider value={state}>
      <GroupDevicesActionContext.Provider value={action}>
        {children}
      </GroupDevicesActionContext.Provider>
    </GroupDevicesContext.Provider>
  );
};
